module.exports = __webpack_public_path__ + "img/egg-fill.23b52d80.svg";